interface HighlightOptions {
	onMatch?: (match: string, isExactMatch: boolean) => void
	caseSensitive?: boolean
	highlightClass?: string
}

const isFullWordMatch = (
	text: string,
	offset: number,
	matchLength: number,
	search: string,
	caseSensitive: boolean
): boolean => {
	const match = text.substr(offset, matchLength)

	const textMatches = caseSensitive
		? match === search
		: match.toLowerCase() === search.toLowerCase()

	if (!textMatches) return false

	const beforeChar = offset > 0 ? text[offset - 1] : ''
	const afterChar = offset + matchLength < text.length ? text[offset + matchLength] : ''

	const wordBoundaryRegex = /\w/
	const isWordBefore = wordBoundaryRegex.test(beforeChar)
	const isWordAfter = wordBoundaryRegex.test(afterChar)

	return !isWordBefore && !isWordAfter
}

export function highlightText(
	text: string,
	search: string,
	options: HighlightOptions = {}
): string {
	if (!search.trim()) {
		return text
	}

	const { onMatch, caseSensitive = false, highlightClass = 'search-highlight' } = options

	const flags = caseSensitive ? 'g' : 'gi'
	const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
	const regex = new RegExp(`(${escapedSearch})`, flags)

	const html = text.replace(regex, (match, captured, offset) => {
		// Trigger onMatch for any match - let the component handle memoization
		if (onMatch) {
			const isExactMatch = isFullWordMatch(text, offset, captured.length, search, caseSensitive)
			onMatch(captured, isExactMatch)
		}

		return `<mark class="${highlightClass}">${captured}</mark>`
	})

	return html
}
